export default "__VITE_ASSET__342ee776__"